"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var pencil = exports.pencil = { "viewBox": "0 0 1536 1792", "children": [{ "name": "path", "attribs": { "d": "M363 1536l91-91-235-235-91 91v107h128v128h107zM886 608q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zM832 416l416 416-832 832h-416v-416zM1515 512q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z" } }] };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/fa/pencil.js
// module id = 1249
// module chunks = 0